import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { c } from '@debbie/cortex/dist';
const ActivateIntegration = (props) => {
    const history = useHistory();
    useEffect(() => {
        const options = props.options != null
            ? JSON.parse(JSON.parse(decodeURIComponent(props.options)))
            : undefined;
        c.integrations.activate(props.id, {
            creditorId: props.creditorId,
            authentication: {
                token: props.token,
            },
            options: options,
        });
        history.push(window.location.pathname);
    }, [props.token]);
    return React.createElement(React.Fragment, null);
};
export default ActivateIntegration;
//# sourceMappingURL=ActivateIntegration.js.map